document.addEventListener('DOMContentLoaded', function () {
  var lists = document.querySelectorAll('.hn-faq-list');

  lists.forEach(function (list) {
    var items = list.querySelectorAll('.hn-faq-item');
    var faqEntries = [];

    // Accordion behavior — always initialize
    items.forEach(function (item) {
      var q = item.querySelector('.hn-faq-question');
      var questionText = item.querySelector('.hn-faq-question-text');
      var answer = item.querySelector('.hn-faq-answer');

      function toggle() {
        var isOpen = item.classList.contains('open');
        if (isOpen) {
          item.classList.remove('open');
          q.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('open');
          q.setAttribute('aria-expanded', 'true');
        }
      }

      q.addEventListener('click', toggle);
      q.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });

      // Collect FAQ entries for schema
      if (questionText && answer) {
        faqEntries.push({
          '@type': 'Question',
          'name': questionText.textContent.trim(),
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': answer.textContent.trim()
          }
        });
      }
    });

    // Generate FAQPage JSON-LD — skip if section already has FAQPage schema
    var hasFaqSchema = false;
    var parentSection = list.closest('section');
    if (parentSection) {
      parentSection.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) {
        if (s.textContent.indexOf('FAQPage') !== -1) hasFaqSchema = true;
      });
    }

    if (!hasFaqSchema && faqEntries.length > 0) {
      var schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': faqEntries
      };

      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  });
});
